import { render, staticRenderFns } from "./SelectedSpecialFeaturesDialog.vue?vue&type=template&id=047a2064"
import script from "./SelectedSpecialFeaturesDialog.vue?vue&type=script&lang=ts"
export * from "./SelectedSpecialFeaturesDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports